import { styled } from "@mui/material/styles";
import { TextField, Box } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  width: theme.spacing(40)
}));

export const StyledHTMLField = styled(TextField)(({ theme }) => ({
  width: theme.spacing(100)
}));

export const StyledInput = styled("input")(({ theme }) => ({
  display: "none"
}));

export const SectionHeader = styled("h3")(({ theme }) => ({
  width: "100%",
  borderBottom: `2px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(0.5),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1)
}));

export const StyledContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.background.light,
  border: "1px solid grey",
  overflow: "hidden",
  position: "fixed",
  top: 130,
  bottom: 65,
  left: 110,
  right: 120,
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.common.layout.offWhite,
  width: "100%"
}));

export const StyledScrollContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  overflowX: "hidden",
  paddingBottom: theme.spacing(2),
  width: "100%",
}));
